import { render, staticRenderFns } from "./FullCard.vue?vue&type=template&id=25309fc5&"
import script from "./FullCard.vue?vue&type=script&lang=js&"
export * from "./FullCard.vue?vue&type=script&lang=js&"
import style0 from "./FullCard.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
